// import React from "react";
// import { Form, Typography, Divider, Space } from "antd";
// import {MailOutlined,LockOutlined,RightOutlined} from "@ant-design/icons";

// import FormInput from "../FormInput";
// import ButtonComponent from "../Button/Button";
// import HeaderComponentWithTitleAndLogo from "../HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
// import MainLayout from "../MainLayout/MainLayout";
// import "./Login.scss";

// const { Link } = Typography;

// const Login = ({ ...props }) => {
//     const onFinish = (values) => {
//         console.log("Login values:", values);
//         props.onFinishHandle(values);
//     };

//     return (
//         <MainLayout>
//             <div className="login-card-new">
//                 {/* Logo */}
//                 <HeaderComponentWithTitleAndLogo
//                     logoSrc="/websiteLogo.png"
//                     logoAlt="Leveridge Logo"
//                     title={props.title}
//                     // subtitle={props.title}
//                 />
//                 <Form
//                     layout="vertical"
//                     className="login-form-new"
//                     onFinish={onFinish}
//                 >
//                     <FormInput
//                         label="Email Address"
//                         name="email"  display: flex;

//                         placeholder="Email Address"
//                         prefix={<MailOutlined />}
//                         rules={[
//                             { required: true, message: "Email is required" },
//                             { type: "email", message: "Enter a valid email" },
//                         ]}
//                     />

//                     <FormInput
//                         label="Password"  display: flex;

//                         name="password"
//                         type="password"
//                         placeholder="Password"
//                         prefix={<LockOutlined />}
//                         rules={[
//                             { required: true, message: "Password is required" },
//                         ]}
//                     />

//                     <Form.Item className="forgot">
//                         <Link onClick={props.forgotPassword}>Forgot password ?</Link>
//                     </Form.Item>
//                     {/* Login Button */}
//                     <Form.Item>
//                         <ButtonComponent
//                             text="Login"
//                             htmlType="submit"
//                             className="login-card-new__button"
//                         />
//                     </Form.Item>
//                     {props.isNewAccountCreateFlag &&
//                         <Form.Item className="forgot create-account-text">
//                             <Link onClick={props.createNewAccount}>Create an account</Link>
//                         </Form.Item>}
//                 </Form>

//                 <Divider>OR</Divider>

//                 {/* Role Links */}
//                 <Space direction="vertical" className="roles">
//                     {props.role !== "investor" && <Link onClick={props.consumerLogin}>Investor <RightOutlined /></Link>}
//                     {props.role !== "administrator" && <Link onClick={props.administratorLogin}>Administrator <RightOutlined /> </Link>}
//                     {props.role !== "capitalProvider" && <Link onClick={props.capitalProviderLogin}>Capital Provider <RightOutlined /> </Link>}
//                 </Space>

//             </div>
//         </MainLayout>
//     );
// };

// export default Login;


import React, { useState, useEffect } from "react";
import { Form, Typography, Divider, Checkbox, Select, Spin, message } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

import FormInput from "../FormInput";
import ButtonComponent from "../Button/Button";
import MainLayout from "../MainLayout/MainLayout";
import "./Login.scss";
import { startMicrosoftLogin, processMicrosoftRedirectResult } from "../../modules/msalService";
import { SESSION_TOKEN } from "../../constants/constants";
import _BankAdminService from "../../modules/BankAdminService";
import { routes } from "../../routes/Routes";

const { Link, Title, Text } = Typography;

/**
 * Stores role-specific localStorage keys (matching the existing email/password
 * login pattern) and navigates to the correct dashboard.
 */
function navigateAfterSso(ssoData, history) {
    const result = ssoData?.backendResult?.Obj;
    const isSuccess = ssoData?.backendResult?.IsSuccess;

    if (!isSuccess || !result?.UserFoundInDatabase) {
        message.error(
            ssoData?.backendResult?.Message ||
            "Your Microsoft account is not registered in this system. Please contact your administrator."
        );
        return;
    }
    if (!result?.AuthToken) {
        message.error("Authentication failed: no session token received. Please try again.");
        return;
    }

    localStorage.setItem(SESSION_TOKEN, result.AuthToken);
    localStorage.setItem("userRole",     result.Role   || "");
    localStorage.setItem("RoleId",       result.RoleId || "");

    switch (result.UserType) {
        case "Banker":
            localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
            localStorage.setItem("BankerEmailId",    result.Email       || "");
            localStorage.setItem("BankerId",         result.AppUserId   || "");
            localStorage.setItem("BankerFirstName",  result.DisplayName || "");
            if (result.BankAdminId)    localStorage.setItem("BankAdminId",    result.BankAdminId);
            if (result.listUserRoles)  localStorage.setItem("listUserRoles",  JSON.stringify(result.listUserRoles));
            history.push(routes.bankerdashboard.path);
            break;

        case "BankAdmin":
            localStorage.setItem("IsLoanofficerFlag",  JSON.stringify(false));
            localStorage.setItem("IsBankAdminFlag",    JSON.stringify(true));
            localStorage.setItem("BankAdminEmailId",   result.Email       || "");
            localStorage.setItem("BankAdminId",        result.AppUserId   || "");
            localStorage.setItem("BankAdminFirstName", result.DisplayName || "");
            history.push(routes.bankadmindashboard.path);
            break;

        case "LoanOfficer":
            localStorage.setItem("IsLoanofficerFlag",   JSON.stringify(true));
            localStorage.setItem("LoanOfficerEmailId",  result.Email       || "");
            localStorage.setItem("LoanOfficerId",       result.AppUserId   || "");
            localStorage.setItem("LoanOfficerFirstName",result.DisplayName || "");
            if (result.listUserRoles)  localStorage.setItem("listUserRoles", JSON.stringify(result.listUserRoles));
            history.push(routes.loanOfficerDashboard.path);
            break;

        case "ComplianceAdmin":
            history.push(routes.complianceadmindashboard.path);
            break;

        default:
            history.push(routes.dashboard.path);
            break;
    }
}

const Login = ({ ...props }) => {
    const [role, setRole] = useState("Applicant");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [ssoConfig, setSsoConfig] = useState(null);
    const [ssoLoading, setSsoLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        async function init() {
            // ── 1. Load tenant SSO config ─────────────────────────────────
            try {
                const stored = localStorage.getItem("tenantInfo");
                if (stored) {
                    setSsoConfig(JSON.parse(stored));
                } else {
                    const res = await _BankAdminService.getTenantInformation();
                    if (res?.data?.IsSuccess && res.data.Obj) {
                        localStorage.setItem("tenantInfo", JSON.stringify(res.data.Obj));
                        setSsoConfig(res.data.Obj);
                    }
                }
            } catch (_) {}

            // ── 2. Process Microsoft redirect result ─────────────────────
            // After startMicrosoftLogin() redirects the browser to Microsoft and
            // the user authenticates (including MFA), Microsoft redirects back to
            // localhost:3000/#code=.... Detect this and complete the login.
            const fragment = window.location.hash.substring(1);
            const params = new URLSearchParams(fragment || window.location.search.substring(1));
            if (!params.get("code")) return;

            setSsoLoading(true);
            try {
                const ssoData = await processMicrosoftRedirectResult();
                if (!ssoData) {
                    message.error("Microsoft authentication failed. Please try again.");
                    setSsoLoading(false);
                    return;
                }
                navigateAfterSso(ssoData, history);
            } catch (err) {
                message.error(err?.message || "Microsoft sign-in failed. Please try again.");
                setSsoLoading(false);
            }
        }
        init();
    }, []);

    const handleMicrosoftLogin = async () => {
        setSsoLoading(true);
        try {
            await startMicrosoftLogin();
            // Browser navigates away to Microsoft — nothing runs after this line.
            // After auth (including MFA), Microsoft redirects back to localhost:3000/.
            // The useEffect above detects #code= in the URL and completes the login.
        } catch (err) {
            setSsoLoading(false);
            message.error(err?.message || "Microsoft login failed. Please try again.");
        }
    };

    const showMicrosoftButton = ssoConfig?.SSOProvider === "Microsoft";

    const onFinish = (values) => {
        props.onFinishHandle({ ...values, role });
    };

    return (
        <MainLayout>
            <div className="login-page createNewPasswordUser">
                <div className="login-card">
                    <Title level={1} >Platform Access</Title>
                    <p className="subtitle">
                        Sign in to access institutional infrastructure for private credit
                    </p>

                    {/* <div class="ant-col ant-form-item-label userTypeLable"><label>User Type</label></div> */}

                    {isMobile ? (
                        <Select
                            value={props.role}
                            onChange={(value) => {
                                if (value === "applicant") props.applicantLogin();
                                if (value === "banker") props.bankerLogin();
                                if (value === "bankAdmin") props.bankerAdminLogin();
                                if (value === "loanOfficer") props.loanOfficerLogin();
                                if (value === "Compliance Administrator") props.complianceAdminLogin();
                            }}
                            className="role-select"
                            options={[
                                { label: "Client", value: "applicant" },
                                { label: "Banker", value: "banker" },
                                { label: "Super Admin", value: "bankAdmin" },
                                { label: "Loan Officer", value: "loanOfficer" },
                                { label: "Compliance Admin", value: "Compliance Administrator" },
                            ]}
                        />
                    ) : (
                        <div className="role-tabs">
                            {[
                                { label: "Client", value: "applicant", onClick: props.applicantLogin },
                                { label: "Banker", value: "banker", onClick: props.bankerLogin },
                                { label: "Super Admin", value: "bankAdmin", onClick: props.bankerAdminLogin },
                                { label: "Loan Officer", value: "loanOfficer", onClick: props.loanOfficerLogin },
                                { label: "Compliance Admin", value: "Compliance Administrator", onClick: props.complianceAdminLogin },
                            ].map((item) => (
                                <button
                                    key={item.value}
                                    className={props.role === item.value ? "active" : ""}
                                    onClick={item.onClick}
                                    type="button"
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    )}

                    <Form layout="vertical" onFinish={onFinish}>
                        <FormInput
                            label="Email Address"
                            name="email"
                            placeholder="Enter Email"
                            prefix={<MailOutlined />}
                            rules={[
                                { required: true, message: "Email is required" },
                                { type: "email", message: "Enter a valid email" },
                            ]}
                        />

                        <FormInput
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            prefix={<LockOutlined />}
                            rules={[
                                { required: true, message: "Password is required" },
                            ]}
                        />

                        <div className="remember-row">
                            <Checkbox defaultChecked>Remember me</Checkbox>
                            <Link className="forgotPasswordLink" onClick={props.forgotPassword}>Forgot password?</Link>
                        </div>

                        <ButtonComponent
                            text="Sign In"
                            htmlType="submit"
                            className="primary-btn f16"
                        />
                    </Form>

                    <Divider className="loginOrDivider">or</Divider>

                    {props.isNewAccountCreateFlag &&
                        <ButtonComponent
                            text="Request Access"
                            className="secondary-btn f16"
                            type="default"
                            onClick={props.createNewAccount}
                        />}

                    <p className="contact-text">
                        Don’t have access? <a style={{color:"#fff"}} target="_blank" href="https://levridge.ai/contact">Contact our team</a>
                    </p>

                    {showMicrosoftButton && (
                        <>
                            <Divider style={{ borderColor: "rgba(255,255,255,0.25)", color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
                                or sign in with
                            </Divider>
                            <Spin spinning={ssoLoading}>
                                <button
                                    type="button"
                                    onClick={handleMicrosoftLogin}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 10,
                                        width: "100%",
                                        padding: "10px 16px",
                                        background: "#ffffff",
                                        color: "#333333",
                                        border: "none",
                                        borderRadius: 6,
                                        fontSize: 14,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        marginTop: 4,
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
                                        <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                                        <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                                        <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                                        <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                                    </svg>
                                    Sign in with Microsoft
                                </button>
                            </Spin>
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

export default Login;
